import { z } from "../xzod";

export const ClientEntrySchema = z.object({
  clientId: z.string().min(1),
  createdAt: z.date(),
});
